module.exports = __webpack_public_path__ + "static/img/astronauta-verde.4ac0695.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/astronauta-verde.gif
// module id = 2082
// module chunks = 5